import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/upgradeFile',
  title: window.language['menu.sysConfig.upgradeFile'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/UpgradeFile/index.js